import useBrand from "./useBrand";

export default function Brand2(props) {
    const { Component, id, ...restProps } = props;

    const brandQuery = useBrand(id);

    if (!id) return undefined;

    if (brandQuery.loading) throw new Promise((resolve) => setTimeout(resolve, 100));
    if (brandQuery.error) return undefined;
    if (!brandQuery.data?.brand) return undefined;

    return (
        <Component
            { ...restProps }
            { ...brandQuery.data.brand }
        />
    );
}
